
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SENTIMENT_QUESTIONS = [
  "What do people think about our product or service quality?",
  "How is our customer service perceived?",
  "What's the sentiment around our recent announcements?",
  "How does our brand compare to competitors?",
  "What features do customers want to see improved?"
];

interface SentimentAnalysisFormProps {
  companyName: string;
  setCompanyName: (name: string) => void;
  selectedQuestion: string;
  setSelectedQuestion: (question: string) => void;
  aiEngine: string;
  setAiEngine: (engine: string) => void;
  onAnalyze: () => void;
  isAnalyzing: boolean;
}

export const SentimentAnalysisForm: React.FC<SentimentAnalysisFormProps> = ({
  companyName,
  setCompanyName,
  selectedQuestion,
  setSelectedQuestion,
  aiEngine,
  setAiEngine,
  onAnalyze,
  isAnalyzing
}) => {
  return (
    <Card className="bg-secondary/50 border-2 border-primary">
      <CardHeader>
        <CardTitle className="text-white">AI Sentiment Analysis</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap items-end gap-4">
          <div className="w-[180px]">
            <label className="text-sm font-medium text-primary-light mb-2 block">Company Name</label>
            <Input 
              placeholder="Enter company name" 
              value={companyName} 
              onChange={e => setCompanyName(e.target.value)} 
              className="bg-[#1A1F2C] border-white text-white w-[180px]" 
            />
          </div>
          
          <div className="w-[420px]">
            <label className="text-sm font-medium text-primary-light mb-2 block">Analysis Topic</label>
            <Select value={selectedQuestion} onValueChange={setSelectedQuestion}>
              <SelectTrigger className="bg-[#1A1F2C] border border-white text-white w-[420px]">
                <SelectValue placeholder="Select a question" />
              </SelectTrigger>
              <SelectContent>
                {SENTIMENT_QUESTIONS.map(question => (
                  <SelectItem key={question} value={question}>
                    {question}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="w-[180px]">
            <label className="text-sm font-medium text-primary-light mb-2 block">AI Engine</label>
            <Select value={aiEngine} onValueChange={setAiEngine}>
              <SelectTrigger className="bg-[#1A1F2C] border border-white text-white">
                <SelectValue placeholder="Select AI Engine" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="openai">OpenAI</SelectItem>
                <SelectItem value="deepseek">DeepSeek</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div className="flex-0 min-w-[150px]">
            <Button 
              onClick={onAnalyze} 
              disabled={isAnalyzing || !companyName} 
              className="w-full bg-primary text-black hover:bg-primary/80"
            >
              {isAnalyzing ? "Analyzing..." : "Analyze Sentiment"}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
